const translation = {
  custom: 'กำหนด เอง',
  upgradeTip: {
    prefix: 'อัปเกรดแผนของคุณเป็น',
    suffix: 'ปรับแต่งแบรนด์ของคุณ',
    des: 'อัปเกรดแผนของคุณเพื่อปรับแต่งแบรนด์ของคุณ',
    title: 'อัปเกรดแผนของคุณ',
  },
  webapp: {
    title: 'ปรับแต่งแบรนด์ web app',
    removeBrand: 'ลบ ขับเคลื่อนโดย Dify',
    changeLogo: 'การเปลี่ยนแปลงที่ขับเคลื่อนโดยภาพลักษณ์ของแบรนด์',
    changeLogoTip: 'รูปแบบ SVG หรือ PNG ที่มีขนาดขั้นต่ํา 40x40px',
  },
  app: {
    title: 'ปรับแต่งแบรนด์ส่วนหัวของแอป',
    changeLogoTip: 'รูปแบบ SVG หรือ PNG ที่มีขนาดขั้นต่ํา 80x80px',
  },
  upload: 'อัปโหลด',
  uploading: 'อัป โหลด',
  uploadedFail: 'อัปโหลดรูปภาพล้มเหลวโปรดอัปโหลดใหม่',
  change: 'เปลี่ยน',
  apply: 'ใช้',
  restore: 'คืนค่าเริ่มต้น',
  customize: {
    contactUs: 'ติดต่อเรา',
    prefix: 'หากต้องการปรับแต่งโลโก้แบรนด์ภายในแอพ โปรด',
    suffix: 'เพื่ออัปเกรดเป็นรุ่น Enterprise',
  },
}

export default translation
